import React, { Component } from 'react';
import Sidebar from '../../components/sidebar';
import { withRouter } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import Fetch from '../../common/fetch.js';


// there are 2 request actions on this page. when user click on any of them, 
// it would trigger an email send to the marketing team
class Request extends Component {
    constructor(props) {
        super(props);
        this.fetch = new Fetch();
        this.state = {};
    }

    // show a confirmation modal after user's click
    async requestHandlerAudit() {
        window.$('#myModal').modal('show');
        await this.sendMktgAction('Request Energy Audit');

    }

    async requestHandlerRetrofit() {
        window.$('#myModal').modal('show');
        await this.sendMktgAction('Request Basic Retrofit');

    }

    // send user's request to the marketing team
    async sendMktgAction(action) {
        // get token from Cognito 
        const user = await Auth.currentAuthenticatedUser();
        const { jwtToken } = user.signInUserSession.idToken;
        // API Gateway route is dev/mktg/request
        // action is in the body to pass to the backend
        const url = 'https://mv9av9jew4.execute-api.us-east-1.amazonaws.com/dev/mktg/request';
        const options = {
            method: 'POST',
            headers: {
                authorization: jwtToken
            },
            body: JSON.stringify({
                action: action
            })
        };

        return await this.fetch.request(url, options);

    }

    render() {
        return (
            <div>
                <Sidebar />
                <div className='container-fluid my-container'>
                    <div className="d-flex h-100 justify-content-center ">
                        <div className="align-self-md-center h-auto w-40 p-4 form-container ">
                            <p className="login-title">REQUEST</p>

                            <button
                                type='button'
                                className='btn btn-info btn-block font-weight-bold'
                                onClick={() => this.requestHandlerAudit()}
                            >
                                REQUEST ENERGY AUDIT
                            </button>
                            <button
                                type='button'
                                className='btn btn-info btn-block font-weight-bold'
                                onClick={() => this.requestHandlerRetrofit()}
                            >
                                REQUEST BASIC RETROFIT
                            </button>



                            <div className="modal" id="myModal">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h4 className="modal-title">Submission Successful</h4>
                                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                                        </div>
                                        <div className="modal-body">
                                            Thank you! You have successfully requested our service. Our staff will contact you via email.
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-info btn-block font-weight-bold" data-dismiss="modal">CLOSE</button>
                                        </div>

                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
export default withRouter(Request);


// WEBPACK FOOTER //
// ./src/routes/request/index.js